import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_3 = { class: "mt-2 text-sm text-gray-600" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger mt-2 text-sm"
}
const _hoisted_5 = { class: "mt-6 flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createBlock($setup["TransitionRoot"], {
    as: "template",
    show: Boolean($props.phone)
  }, {
    default: _withCtx(() => [
      _createVNode($setup["Dialog"], {
        as: "div",
        class: "relative z-50",
        onClose: $setup.close
      }, {
        default: _withCtx(() => [
          _createVNode($setup["TransitionChild"], {
            as: "template",
            enter: "ease-out duration-200",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-150",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75" }, null, -1 /* CACHED */)
            ])),
            _: 1 /* STABLE */,
            __: [1]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode($setup["TransitionChild"], {
                as: "template",
                enter: "ease-out duration-200",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-150",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["DialogPanel"], { class: "w-full max-w-md rounded-lg bg-white p-6 shadow-xl" }, {
                    default: _withCtx(() => [
                      _createVNode($setup["DialogTitle"], { class: "text-lg font-semibold text-gray-800" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('whatsappMeta.activationDialog.title')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createElementVNode("p", _hoisted_3, [
                        _createTextVNode(_toDisplayString($setup.t('whatsappMeta.activationDialog.descriptionBeforeNumber')) + " ", 1 /* TEXT */),
                        _createElementVNode("strong", null, _toDisplayString($props.phone?.displayPhoneNumber || $props.phone?.phoneNumberId), 1 /* TEXT */),
                        _createTextVNode(_toDisplayString($setup.t('whatsappMeta.activationDialog.descriptionAfterNumber')), 1 /* TEXT */)
                      ]),
                      _createElementVNode("form", {
                        class: "mt-5",
                        onSubmit: _withModifiers($setup.submit, ["prevent"])
                      }, [
                        _createVNode(_component_UiTextInput, {
                          modelValue: $setup.pin,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.pin) = $event)),
                          label: $setup.t('whatsappMeta.activationDialog.pinLabel'),
                          name: "whatsapp-registration-pin",
                          type: "password",
                          inputmode: "numeric",
                          maxlength: "6",
                          autocomplete: "new-password",
                          placeholder: "000000"
                        }, null, 8 /* PROPS */, ["modelValue", "label"]),
                        ($setup.pin && !$setup.isValid)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.t('whatsappMeta.activationDialog.invalidPin')), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_UiButton, {
                            variant: "white",
                            "text-variant": "primary",
                            onClick: $setup.close
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('whatsappMeta.activationDialog.cancel')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_UiButton, {
                            "html-type": "submit",
                            variant: "primary",
                            "text-variant": "white",
                            disabled: !$setup.isValid || $props.isSubmitting
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('whatsappMeta.activationDialog.activate')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["disabled"])
                        ])
                      ], 32 /* NEED_HYDRATION */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}